import React, { Component } from 'react';
import {
    PageListComponent, HeaderListComponent,
} from "../../../../common/component/Index";

import Wrapper from '../../../../common/component/Wrapper';

import { omit } from 'lodash';
import ReportList from './ReportList';

import './OrderDetailReportsByHotel.less';

export default class OrderDetailReportsByHotel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
        };
    }

    componentDidMount() {
        this.getSaleDetailReportsByHotel()
    }

    render() {
        const { t, hideHeader, reportState, orderState } = this.props;
        const { isFetching, saleDetailReportByHotel } = reportState;
        return (
            <PageListComponent className="page-sale-report">
                {!hideHeader &&
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'orders'}
                        titleHeader={t('item.report.orderDetailReportsByHotel')}
                    />
                }
                <Wrapper className="">
                    <ReportList report={saleDetailReportByHotel}
                        loading={isFetching}
                        downloading={orderState.isFetchingDownload}
                        onChangeFilters={this.getSaleDetailReportsByHotel}
                        onExportExcel={this.onExportExcel}
                    />
                </Wrapper>
            </PageListComponent>
        );
    }

    getSaleDetailReportsByHotel = (filters) => {
        const { reportState } = this.props;
        if (!filters) filters = omit(reportState.saleDetailReportByHotel, ['items']);
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSaleDetailReportByHotel(filters);
    }

    onExportExcel = (filters) => {
        this.props.exportHotelSaleDetailExcel(filters);
    }

}

OrderDetailReportsByHotel.defaultProps = {
    hideHeader: false,
}
